import { render, staticRenderFns } from "./AppFeatures.vue?vue&type=template&id=f4d4f44e&"
import script from "./AppFeatures.vue?vue&type=script&lang=js&"
export * from "./AppFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AppFeatures.vue"
export default component.exports